import { map, filter, find } from 'lodash';
import moment from 'moment';

export const fetchFilteredStatusCounts = (filteredThings , parkTimeThreshold) => {
  const statusMapping = {
    DEVICE_UNPLUG: 'unplugCount',
    IGNITION_OFF: 'parkedCount',
    DEVICE_PLUG_IN: 'pluginCount',
    IGNITION_ON: 'ignitionCount',
    VEHICLE_MOVING: 'movingCount',
    NEVER_HEARD: 'neverHeard',
    NOT_RESPONDING: 'notResponding',
    IDLE: 'idleCount'
  };

  const grouped = filteredThings?.reduce((acc, item) => {
    const groupId = item.groupId;
    const groupName = item?.group || 'Unknown Group';

    if (!acc[groupId]) {
      acc[groupId] = {
        groupId,
        groupName,
        unplugCount: 0,
        parkedCount: 0,
        pluginCount: 0,
        ignitionCount: 0,
        movingCount: 0,
        neverHeard: 0,
        notResponding: 0,
        idleCount: 0,
        simstatus: 0,
        totalVehicles: 0,
        parkedOverThresholdCount: 0,

      };
    }

    const groupData = acc[groupId];
    const statusKey = statusMapping[item.vehicleStatus];

    if (statusKey) {
      groupData[statusKey]++;
    }

    if (item.vehicleStatus === "IGNITION_OFF") {
      const minutesParked = moment().diff(moment(item.lastStatusChange), "minutes");
      if (minutesParked > parkTimeThreshold) {
        groupData.parkedOverThresholdCount++;
      }
    }

    

    groupData.totalVehicles++;

    return acc;
  }, {});

  return Object.values(grouped);
};









export const formatGroupList = (groupList, optionKeys = { labelKey: 'name', valueKey: 'name', childKey: 'child' }) => {
  return map(groupList, group => {
    const option = { label: group[optionKeys.labelKey], value: group[optionKeys.valueKey] };
    if (group.child && group.child.length) option.options = formatGroupList(group.child, optionKeys);
    return option;
  })
};



export const filterVehicleList = (vehicleList = [], groupList = [], status = '', selected = []) => {
  selected = selected || [];
  if (!status) {
    status = ''
  }
  if (groupList) {
    if (!groupList.length && !status && !selected.length) {
      return vehicleList;
    }

    if (!groupList.length && !status && selected.length) {
      return filter(
        vehicleList, item => {
          return find(selected, ['value', item._id]) ? true : false
        }
      );
    }
    if (!groupList.length && status && !selected.length) {
      return filter(
        vehicleList, item => {
          return item.vehicleStatus === status.value
        }
      );
    }
    if (groupList.length && !status && !selected.length) {
      return filter(
        vehicleList, item => {
          return find(groupList, ['value', item.groupId || item.group]) ? true : false
        }
      );
    }
  }

  return filter(
    vehicleList, item =>
      !(groupList && groupList.length && !find(groupList, ['value', item.groupId || item.group]))
        ? !(status && item.vehicleStatus !== status.value) && (!selected.length || find(selected, ['value', item._id]))
        : false
  );
};
export const countVehiclesParkedOverThresholdTotal = (
  parkTimeThreshold,
  vehicleList = [],
  groupList = [],
  status = [],
  selected = []
) => {
  selected = selected || [];
  groupList = groupList === null ? [] : groupList;
  if (!status) {
    status = [];
  }
  let filteredVehicles = filter(vehicleList, (item) => {
    const inGroup =
      !groupList.length || find(groupList, ["value", item.groupId || item.group]);
    const inStatus = !status.length || status.includes(item.vehicleStatus);
    const inSelected = !selected.length || find(selected, ["value", item._id]);

    let passes = inGroup && inStatus && inSelected;

    if (
      passes &&
      status.includes("IGNITION_OFF") &&
      item.vehicleStatus === "IGNITION_OFF"
    ) {
      const minutesParked = moment().diff(moment(item.lastStatusChange), "minutes");
      passes = minutesParked > parkTimeThreshold;
    }

    return passes;
  });

  const count = filteredVehicles.filter(
    (item) =>
      item.vehicleStatus === "IGNITION_OFF" &&
      moment().diff(moment(item.lastStatusChange), "minutes") > parkTimeThreshold
  ).length;

  return count;
};
export const filterVehicleListingPunjabForest = (

  customParkedTimeFilter,

  parkTimeThreshold,

  vehicleList = [],

  groupList = [],

  status = [],

  selected = [],

  type = ""

) => {

  selected = selected || [];

  groupList = groupList === null ? [] : groupList;

  console.log("what is type", type);

  if (!status) {

    status = [];

  }

  if (!groupList) {

    return vehicleList;

  }

  if (!groupList.length && !status.length && !selected.length) {

    // TYPE FILTER
    if (type) {
      return filter(vehicleList, (item) => item.thingType === type);
    }

    return vehicleList;

  }

  if (!groupList.length && !status.length && selected.length) {

    return filter(vehicleList, (item) => {

      const inSelected = find(selected, ["value", item._id]);

      // TYPE FILTER
      const inType = !type || item.thingType === type;

      return inSelected && inType;

    });

  }

  if (!groupList.length && status.length && !selected.length) {

    if (status.includes("WEAK_SIGNAL")) {

      return filter(

        vehicleList,

        (item) => {

          const inStatus =
            status.includes(item.vehicleStatus) ||
            moment(item.lastStatusChange).isBefore(
              moment().subtract(2, "minute")
            );

          // TYPE FILTER
          const inType = !type || item.thingType === type;

          return inStatus && inType;
        }

      );

    } else if (status.includes("IGNITION_OFF") && customParkedTimeFilter) {

      const parkedFiltered = vehicleList.filter((item) => {

        return (

          item.vehicleStatus === "IGNITION_OFF" &&

          moment().diff(
            moment(item.lastStatusChange),
            "minutes"
          ) > parkTimeThreshold &&

          // TYPE FILTER
          (!type || item.thingType === type)

        );

      });

      // Sort by parked time from least to most

      return parkedFiltered.sort((a, b) =>
        moment(b.lastStatusChange).diff(moment(a.lastStatusChange))
      );

    } else {

      return filter(vehicleList, (item) => {

        return (

          status.includes(item.vehicleStatus) &&

          // TYPE FILTER
          (!type || item.thingType === type)

        );

      });

    }

  }

  if (groupList.length && !status.length && !selected.length) {

    return filter(vehicleList, (item) => {

      return (

        find(
          groupList,
          ["value", item.groupId || item.group]
        ) &&

        // TYPE FILTER
        (!type || item.thingType === type)

      );

    });

  }

  return filter(vehicleList, (item) => {

    const inGroup =

      !groupList.length ||
      find(groupList, ["value", item.groupId || item.group]);

    const inStatus =
      !status.length ||
      status.includes(item.vehicleStatus);

    const inSelected =
      !selected.length ||
      find(selected, ["value", item._id]);

    // TYPE FILTER
    const inType =
      !type || item.thingType === type;

    let passes =
      inGroup &&
      inStatus &&
      inSelected &&
      inType;

    if (

      passes &&

      status.includes("IGNITION_OFF") &&

      customParkedTimeFilter &&

      item.vehicleStatus === "IGNITION_OFF"

    ) {

      const minutesParked = moment().diff(
        moment(item.lastStatusChange),
        "minutes"
      );

      passes = minutesParked > parkTimeThreshold;

    }

    return passes;

  }).sort((a, b) => {

    if (

      customParkedTimeFilter &&

      status.includes("IGNITION_OFF") &&

      a.vehicleStatus === "IGNITION_OFF" &&

      b.vehicleStatus === "IGNITION_OFF"

    ) {

      return moment(b.lastStatusChange).diff(
        moment(a.lastStatusChange)
      );

    }

    return 0; // don't sort if not needed

  });

};


export const filterVehicleListing = (

  customParkedTimeFilter,
  parkTimeThreshold,
  vehicleList = [],
  groupList = [],
  status = [],
  selected = []
) => {
  selected = selected || [];
  groupList = groupList === null ? [] : groupList;
  if (!status) {
    status = [];
  }
  if (!groupList) {
    return vehicleList;
  }
  if (!groupList.length && !status.length && !selected.length) {
    return vehicleList;
  }
  if (!groupList.length && !status.length && selected.length) {
    return filter(vehicleList, (item) => {
      return find(selected, ["value", item._id]) ? true : false;
    });
  }
  if (!groupList.length && status.length && !selected.length) {
    if (status.includes("WEAK_SIGNAL")) {
      return filter(
        vehicleList,
        (item) =>
          status.includes(item.vehicleStatus) ||
          moment(item.lastStatusChange).isBefore(moment().subtract(2, "minute"))
      );
    } else if (status.includes("IGNITION_OFF") && customParkedTimeFilter) {
      const parkedFiltered = vehicleList.filter((item) => {
        return (
          item.vehicleStatus === "IGNITION_OFF" &&
          moment().diff(moment(item.lastStatusChange), "minutes") > parkTimeThreshold
        );
      });

      // Sort by parked time from least to most
      return parkedFiltered.sort((a, b) =>
        moment(b.lastStatusChange).diff(moment(a.lastStatusChange))
      )
    } else {
      return filter(vehicleList, (item) => status.includes(item.vehicleStatus));
    }
  }

  if (groupList.length && !status.length && !selected.length) {
    return filter(vehicleList, (item) => {
      return find(groupList, ["value", item.groupId || item.group]) ? true : false;
    });
  }

  return filter(vehicleList, (item) => {
    const inGroup =
      !groupList.length || find(groupList, ["value", item.groupId || item.group]);
    const inStatus = !status.length || status.includes(item.vehicleStatus);
    const inSelected = !selected.length || find(selected, ["value", item._id]);

    let passes = inGroup && inStatus && inSelected;

    if (
      passes &&
      status.includes("IGNITION_OFF") &&
      customParkedTimeFilter &&
      item.vehicleStatus === "IGNITION_OFF"
    ) {
      const minutesParked = moment().diff(moment(item.lastStatusChange), "minutes");
      passes = minutesParked > parkTimeThreshold;
    }

    return passes;
  }).sort((a, b) => {
    if (
      customParkedTimeFilter &&
      status.includes("IGNITION_OFF") &&
      a.vehicleStatus === "IGNITION_OFF" &&
      b.vehicleStatus === "IGNITION_OFF"
    ) {
      return moment(b.lastStatusChange).diff(moment(a.lastStatusChange));
    }
    return 0; // don't sort if not needed
  });
};



// export const filterVehicleListing = (vehicleList = [], groupList = [], status = [], selected = []) => {
  
//   selected = selected || [];
//   groupList = groupList === null ? [] : groupList;
//   if (!status) {
//     status = []
//   }
//   if (!groupList) {
//     return vehicleList;
//   }
//   if (!groupList.length && !status.length && !selected.length) {
//     return vehicleList;
//   }
//   if (!groupList.length && !status.length && selected.length) {
//     return filter(
//       vehicleList, item => {
//         return find(selected, ['value', item._id]) ? true : false
//       }
//     );
//   }
//   if (!groupList.length && status.length && !selected.length) {
//     if (status.includes("WEAK_SIGNAL")) {
//       return filter(
//         vehicleList,
//         (item) =>
//           status.includes(item.vehicleStatus) || 
//           moment(item.lastObservationTime).isBefore(moment().subtract(2, 'minute'))
//       );
//     } else {
//       return filter(
//         vehicleList,
//         (item) => status.includes(item.vehicleStatus)
//       );
//     }
//   }
//   // if (!groupList.length && status.length && !selected.length) {
//   //   return filter(
//   //     vehicleList, item => {
//   //       return status.includes(item.vehicleStatus)
//   //     }
//   //   );
//   // }
  
//   if (groupList.length && !status.length && !selected.length) {
//     return filter(
//       vehicleList, item => {
//         return find(groupList, ['value', item.groupId || item.group]) ? true : false
//       }
//     );
//   }
//   return filter(
//     vehicleList, item => {
//       return !(groupList && groupList.length && !find(groupList, ['value', item.groupId || item.group]))
//         ? ((!status.length) || (status && status.includes(item.vehicleStatus))) && (!selected.length || find(selected, ['value', item._id]))
//         : false
//     }
//   );
// };
